// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__tdOvV","mainContent":"MainLayout_mainContent__HiRhh","contentArea":"MainLayout_contentArea__tUmx1"};